import Fuse from 'fuse.js';
const searchAssets = (assets, query) => {
    if (!query)
        return [];
    return new Fuse(assets, {
        keys: [
            { name: 'displayTicker', weight: 0.45 },
            { name: 'displayName', weight: 0.45 },
            { name: 'displayNetworkTicker', weight: 0.05 },
            { name: 'displayNetworkName', weight: 0.05 },
        ],
        threshold: 0.1,
    }).search(query);
};
export default searchAssets;
